import { render } from "./SwitchToggle.vue?vue&type=template&id=5dcf7e8c&ts=true"
import script from "./SwitchToggle.vue?vue&type=script&lang=ts"
export * from "./SwitchToggle.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\src\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__